var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.is_errand_send)?_c('ErrandOrderSendCard',{attrs:{"order":_vm.order},on:{"refresh":_vm.refreshData}}):(_vm.is_errand_buy)?_c('ErrandOrderBuyCard',{attrs:{"order":_vm.order},on:{"refresh":_vm.refreshData}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }